import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { breakpoint } from '../../../../../../../../admin/javascript/contract/duck/grid';

import {
  groupReserve,
  isDesktopDevice,
  groupReservationDefaultDateFilters
} from '../../../../../../services/services';
import { T } from '../../../../../../../../common/locale/translate';
import { Validate } from '../../../../../../../../common/validation/validate';
import DatePicker from '../../../../../../common/components/datepicker';
import {
  SectionHeader,
  ContinueButton,
  SectionSubheader,
  ButtonWrapper
} from '../../../../../reservation/default/styled-components';
import TextInput from '../../../../../reservation/default/input';

class GroupReservationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      showErrors: false,
      dataProtection: false,
      isSending: false,

      destination: '',
      search_from: groupReservationDefaultDateFilters().from,
      search_to: groupReservationDefaultDateFilters().to,
      max_price: '',
      participants_number: '',
      trip_type: {
        bus: false,
        flight: false,
        self_arrival: false
      },
      departure_from: '',
      comment: '',

      client_first_name: '',
      client_last_name: '',
      client_phone: '',
      client_email: '',
      client_club: '',

      destination_class: '',
      client_email_class: ''
    };
  }

  getChildContext() {
    return { muiTheme: getMuiTheme() };
  }

  render() {
    return (
      <GroupReservationWrapper
        id="group_reservation_form_wrapper"
        className={this.props.className}
      >
        {this.renderStep()}
      </GroupReservationWrapper>
    );
  }

  renderStep = () => {
    const {
      step,
      showErrors,
      dataProtection,

      destination,
      search_from,
      search_to,
      max_price,
      participants_number,
      trip_type,
      departure_from,
      comment,

      client_first_name,
      client_last_name,
      client_phone,
      client_email,
      client_club,

      destination_class,
      client_email_class
    } = this.state;

    console.log('1', destination_class);
    console.log('2', client_email_class);

    switch (step) {
      case 2:
        return (
          <CenterWrapper>
            <ThankYouIcon src="/img/icons/check-circle.svg" alt="" />
            <ThankYouHeader>{T('group_reservation_thank_you')}</ThankYouHeader>
            <ThankYouText>{T('group_reservation_contact_msg_1')}</ThankYouText>
            <ThankYouText>{T('group_reservation_contact_msg_2')}</ThankYouText>
          </CenterWrapper>
        );
      default:
        return (
          <div>
            <StyledSectionHeader>
              <strong>{T('group_reservation_info')}</strong>
            </StyledSectionHeader>

            <ColumnWrapper>
              <InputWrapper fullWidth>
                <TextInput
                  requiredRed
                  label={T('group_reservation_destination')}
                  name="destination"
                  class={destination_class}
                  value={destination}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                  validationMessage={T('invalid_destination')}
                />
              </InputWrapper>
              <InputWrapper>
                <StyledDatePicker
                  requiredRed
                  title={T('group_reservation_from')}
                  name="search_from"
                  date={search_from}
                  onChange={value => this.setState({ search_from: value })}
                  withPortal={!isDesktopDevice()}
                />
              </InputWrapper>
              <InputWrapper>
                <StyledDatePicker
                  requiredRed
                  title={T('group_reservation_to')}
                  name="search_to"
                  date={search_to}
                  onChange={value => this.setState({ search_to: value })}
                  withPortal={!isDesktopDevice()}
                />
              </InputWrapper>
              <InputWrapper>
                <TextInput
                  label={T('group_reservation_max_price')}
                  name="max_price"
                  value={max_price}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <TextInput
                  label={T('group_reservation_participants_number')}
                  name="participants_number"
                  value={participants_number}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
            </ColumnWrapper>

            <ColumnWrapper>
              <InputWrapper fullWidth>
                <TripTypeHeader>
                  <span>{T('group_reservation_offer_type')}</span>
                </TripTypeHeader>
                {Object.keys(trip_type).map(type => (
                  <TripTypeWrapper>
                    <input
                      type="checkbox"
                      id={`trip_type_${type}`}
                      name="trip_type"
                      onChange={this.handleTripTypeChange}
                      value={type}
                      checked={trip_type[type]}
                    />
                    <label htmlFor={`trip_type_${type}`}>{T(type)}</label>
                  </TripTypeWrapper>
                ))}
              </InputWrapper>
              <InputWrapper fullWidth>
                <TextInput
                  label={T('group_reservation_departure_from')}
                  name="departure_from"
                  value={departure_from}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
              <InputWrapper fullWidth>
                <TextInput
                  label={T('group_reservation_comment')}
                  name="comment"
                  value={comment}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
            </ColumnWrapper>

            <StyledSectionHeader>
              <strong>{T('person_data')}</strong>
            </StyledSectionHeader>

            <ColumnWrapper fullWidth>
              <InputWrapper left>
                <TextInput
                  label={T('first_name')}
                  name="client_first_name"
                  value={client_first_name}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
              <InputWrapper right>
                <TextInput
                  label={T('last_name')}
                  name="client_last_name"
                  value={client_last_name}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
              <InputWrapper left>
                <TextInput
                  requiredRed
                  label={T('group_reservation_your_email')}
                  name="client_email"
                  class={client_email_class}
                  value={client_email}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                  validationMessage={T('invalid_email')}
                />
              </InputWrapper>
              <InputWrapper right>
                <TextInput
                  label={T('phone_or_mobile_number')}
                  name="client_phone"
                  value={client_phone}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
              <InputWrapper left>
                <TextInput
                  label={T('club')}
                  name="client_club"
                  value={client_club}
                  onChangeCallback={(name, value) =>
                    this.setState({ [name]: value })
                  }
                />
              </InputWrapper>
            </ColumnWrapper>

            <StyledSectionHeader>
              <strong>
                {T('data_protection_consent_header')}
                <span style={{ color: '#f44336' }}>*</span>
              </strong>
            </StyledSectionHeader>
            <StyledSectionSubheader>
              <input
                type="checkbox"
                id="dataProtection"
                name="dataProtection"
                onChange={() =>
                  this.setState({ dataProtection: !dataProtection })
                }
                checked={dataProtection}
              />
              <DataProtectionLabel htmlFor="dataProtection">
                {T('data_protection_content')}
              </DataProtectionLabel>
              {showErrors &&
                !dataProtection && (
                  <ErrorText>{T('data_protection_error')}</ErrorText>
                )}
            </StyledSectionSubheader>

            <StyledSectionHeader>
              <strong>{T('data_protection')}</strong>
            </StyledSectionHeader>
            <StyledSectionSubheader>
              {T('data_protection_info')}
            </StyledSectionSubheader>

            <ButtonWrapper>
              <StyledContinueButton onClick={() => this.handleReserve()}>
                {T('request_free_offer')}
              </StyledContinueButton>
            </ButtonWrapper>
          </div>
        );
    }
  };

  handleTripTypeChange = event => {
    const type = event.target.value;
    this.setState(prevState => ({
      ...prevState,
      trip_type: {
        ...prevState.trip_type,
        [type]: !prevState.trip_type[type]
      }
    }));
  };

  handleReserve = () => {
    if (this.state.step === 1 && !this.validateForm()) {
      return this.setState({ showErrors: true }, () => this.scrollToForm());
    }

    if (!this.state.isSending) {
      this.setState({ isSending: true });
      const params = this.getBookParams();
      groupReserve(params, this.props.csrfToken)
        .then(response => {
          if (!response.data) {
            alert(T('reservation_error'));
            return;
          }

          this.setState({ step: 2 }, () => this.scrollToForm());
        })
        .finally(() => {
          this.setState({ isSending: false });
        });
    }
  };

  getBookParams = () => {
    return {
      ...this.state,
      search_from: moment.unix(this.state.search_from).format('YYYY-MM-DD'),
      search_to: moment.unix(this.state.search_to).format('YYYY-MM-DD')
    };
  };

  validateForm = () => {
    let valid = true;
    if (!this.state.dataProtection) {
      valid = false;
    }
    if (!this.validateField('destination')) {
      valid = false;
    }
    if (!this.validateField('client_email')) {
      valid = false;
    }
    return valid;
  };

  validateField = fieldName => {
    let fieldValue = this.state[fieldName];

    if (!Validate.notBlank(fieldValue)) {
      this.setState({
        [fieldName + '_class']: 'invalid'
      });
      return false;
    } else {
      this.setState({ [fieldName + '_class']: '' });
      return true;
    }
  };

  scrollToForm = () => {
    const element = document.getElementById('group_reservation_form_wrapper');
    element.scrollIntoView();
    window.scrollBy(0, -100);
  };
}

GroupReservationForm.childContextTypes = {
  muiTheme: React.PropTypes.object.isRequired
};

const GroupReservationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.m`
    flex-direction: row;
  `};
`;

const InputWrapper = styled.div`
  width: ${({ fullWidth, left, right }) =>
    fullWidth || left || right ? 'calc(100% - 20px)' : 'calc(50% - 20px)'};
  display: inline-block;
  margin: 0 10px 10px 10px;

  ${breakpoint.m`
    width: ${({ fullWidth, left, right }) =>
      fullWidth
        ? 'calc(100% - 20px)'
        : left || right
          ? 'calc(50% - 30px)'
          : 'calc(50% - 20px)'};
    margin: 0 10px;
    margin-right: ${({ left }) => (left ? '20px' : '10px')};
    margin-left: ${({ right }) => (right ? '20px' : '10px')};
    height: 65px;
  `};
`;

const ColumnWrapper = styled.div`
  display: inline-block;
  width: calc(100% - 20px);
  margin: 0 10px;
  vertical-align: top;

  ${breakpoint.m`
    width: ${({ fullWidth }) =>
      fullWidth ? 'calc(100% - 20px)' : 'calc(50% - 20px)'};
  `};
`;

const StyledSectionHeader = styled(SectionHeader)`
  margin: 0;
  background-color: #fff;
`;

const StyledDatePicker = styled(DatePicker)`
  &.datepicker-wrapper {
    width: 100%;
    margin-bottom: 15px;
    .react-datepicker {
      font-size: 1rem;
    }
    .react-datepicker__input-container {
      width: 100%;
      height: 100%;
      input {
        cursor: pointer;
        width: 100%;
        background: transparent;
        border: none;
        border-radius: 0;
        font-weight: 500;
        font-size: 15px;
        vertical-align: bottom;
        display: inline-block;
        position: absolute;
        bottom: 0.2rem;
        left: 0;
      }
    }
    span.animated-text-label-name {
      display: block;
      top: 0;
      font-size: 15px;
    }
    img.input-icon {
      right: 1px;
      left: auto;
    }
  }
`;

const TripTypeWrapper = styled.div`
  display: inline-block;
  margin-right: 1rem;
`;

const TripTypeHeader = styled.label`
  display: block;
  width: 100%;
  margin-bottom: 5px;
  span {
    font-size: 15px;
  }
`;

const StyledContinueButton = styled(ContinueButton)`
  margin: 0 auto;
  line-height: normal;
`;

const DataProtectionLabel = styled.label`
  && {
    font-size: 13px;
    line-height: normal;
  }
`;

const StyledSectionSubheader = styled(SectionSubheader)`
  margin: 0 0 1rem 0;
  width: 100%;
`;

const ErrorText = styled.div`
  font-size: 0.6rem;
  padding-top: 0.4rem;
  color: #e6004c;
`;

const CenterWrapper = styled.div`
  width: 100%;
  padding: 100px 0;
  text-align: center;
`;

const ThankYouIcon = styled.img`
  width: 60px;
  height: 60px;
`;

const ThankYouHeader = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  padding: 20px;
`;

const ThankYouText = styled.div`
  padding-bottom: 4px;
`;

export default styled(GroupReservationForm)`
  display: inline-block;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;

  ${breakpoint.m`
    width: calc(100% - 20px - 1.5rem);
    margin-left: 1.5rem;
    padding: 20px 10px;
  `};
`;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/group-reservation/index.js